// Must exactly match BlockingWarningMarker.UW_ACTION_BLOCKED in
// mothership/sdk/src/main/java/com/cowbell/server/mothership/sdk/rater_x/major/v1/context/BlockingWarningMarker.java
export const UW_ACTION_BLOCKED_MARKER = 'UW Action Blocked until resolved';

export const hasBlockingWarning = (warnings?: string[]): boolean =>
  Boolean(warnings?.some((warning) => warning.includes(UW_ACTION_BLOCKED_MARKER)));

/**
 * Returns the full warning messages sent by the rater that carry the blocking
 * marker, so they can be surfaced verbatim to the underwriter.
 */
export const getBlockingWarnings = (warnings?: string[]): string[] =>
  warnings?.filter((warning) => warning.includes(UW_ACTION_BLOCKED_MARKER)) ?? [];
